
export const UITEXTS_FETCH = 'uitextsFetch';
export const UITEXTS_FETCH_NS = 'uitexts/uitextsFetch';

export const COMPANION_FETCH = 'companionFetch';
export const COMPANION_FETCH_NS = 'companion/companionFetch';

export const COMPANION_FILTER_TOPIC_CHANGE = 'companionFilterTopicChange';
export const COMPANION_FILTER_TOPIC_CHANGE_NS = 'companionFilter/companionFilterTopicChange';
export const COMPANION_FILTER_CATEGORY_ADD = 'companionFilterCategoryAdd';
export const COMPANION_FILTER_CATEGORY_ADD_NS = 'companionFilter/companionFilterCategoryAdd';
export const COMPANION_FILTER_CATEGORY_REMOVE = 'companionFilterCategoryRemove';
export const COMPANION_FILTER_CATEGORY_REMOVE_NS = 'companionFilter/companionFilterCategoryRemove';
export const COMPANION_FILTER_SEARCH = 'companionFilterSearch';
export const COMPANION_FILTER_SEARCH_NS = 'companionFilter/companionFilterSearch';

export const NUGGET_FETCH = 'nuggetFetch';
export const NUGGET_FETCH_NS = 'nugget/nuggetFetch';
export const NUGGET_SET = 'nuggetSet';
export const NUGGET_SET_NS = 'nugget/nuggetSet';
export const NUGGET_RESET = 'nuggetReset';
export const NUGGET_RESET_NS = 'nugget/nuggetReset';
export const NUGGET_RESET_STATE = 'nuggetResetState';

export const ME_FETCH = 'meFetch';
export const ME_FETCH_NS = 'me/meFetch';
export const ME_POST = 'mePost';
export const ME_POST_NS = 'me/mePost';
export const ME_RESET = 'meReset';
export const ME_RESET_NS = 'me/meReset';

export const KAM_FETCH = 'kamFetch';
export const KAM_FETCH_NS = 'kam/kamFetch';

export const APPOINTMENT_FETCH = 'appointmentFetch';
export const APPOINTMENT_FETCH_NS = 'appointment/appointmentFetch';
export const APPOINTMENT_BOOKED = 'appointmentBooked';
export const APPOINTMENT_BOOKED_NS = 'appointment/appointmentBooked';
export const APPOINTMENT_BOOK = 'appointmentBook';
export const APPOINTMENT_BOOK_NS = 'appointment/appointmentBook';
export const APPOINTMENT_CANCEL = 'appointmentCancel';
export const APPOINTMENT_CANCEL_NS = 'appointment/appointmentCancel';
export const APPOINTMENT_BLOCK = 'appointmentBlock';
export const APPOINTMENT_BLOCK_NS = 'appointment/appointmentBlock';
export const APPOINTMENT_CANCEL_KAM = 'appointmentCancelKam';
export const APPOINTMENT_CANCEL_KAM_NS = 'appointment/appointmentCancelKam';

export const STANDGUIDANCE_FETCH = 'standGuidanceFetch';
export const STANDGUIDANCE_FETCH_NS = 'standGuidance/standGuidanceFetch';
export const STANDGUIDANCE_BOOKED = 'standGuidanceBooked';
export const STANDGUIDANCE_BOOKED_NS = 'standGuidance/standGuidanceBooked';
export const STANDGUIDANCE_BOOK = 'standGuidanceBook';
export const STANDGUIDANCE_BOOK_NS = 'standGuidance/standGuidanceBook';
export const STANDGUIDANCE_CANCEL = 'standGuidanceCancel';
export const STANDGUIDANCE_CANCEL_NS = 'standGuidance/standGuidanceCancel';

export const GENERAL_ENTRY_FETCH = 'generalEntryFetch';
export const GENERAL_ENTRY_FETCH_NS = 'generalEntry/generalEntryFetch';
export const GENERAL_ENTRY_SET = 'generalEntrySet';
export const GENERAL_ENTRY_SET_NS = 'generalEntry/generalEntrySet';
export const GENERAL_ENTRY_RESET = 'generalEntryReset';
export const GENERAL_ENTRY_RESET_NS = 'generalEntry/generalEntryReset';

export const PAGE_FETCH = 'pageFetch';
export const PAGE_FETCH_NS = 'page/pageFetch';
export const PAGE_SET = 'pageSet';
export const PAGE_SET_NS = 'page/pageSet';
export const PAGE_RESET = 'pageReset';
export const PAGE_RESET_NS = 'page/pageReset';

export const COLLECTION_FETCH = 'collectionFetch';
export const COLLECTION_FETCH_NS = 'collection/collectionFetch';
export const COLLECTION_SET = 'collectionSet';
export const COLLECTION_SET_NS = 'collection/collectionSet';

export const KNOWLEDGE_TEST_FETCH = 'knowledgeTestFetch';
export const KNOWLEDGE_TEST_FETCH_NS = 'knowledgeTest/knowledgeTestFetch';
export const KNOWLEDGE_TEST_SET = 'knowledgeTestSet';
export const KNOWLEDGE_TEST_SET_NS = 'knowledgeTest/knowledgeTestSet';

export const APP_SWITCH_LANGUAGE = 'appSwitchLanguage';
export const APP_SWITCH_LANGUAGE_NS = 'uitexts/appSwitchLanguage';

export const AUTHENTICATION_LOGIN = 'authenticationLogin';
export const AUTHENTICATION_LOGIN_NS = 'authentication/authenticationLogin';
export const AUTHENTICATION_LOGOUT = 'authenticationLogout';
export const AUTHENTICATION_LOGOUT_NS = 'authentication/authenticationLogout';

export const HEADER_PIN_CHANGED = 'headerPinChanged';
export const HEADER_PIN_CHANGED_NS = 'header/headerPinChanged';
export const HEADER_HEIGHT_CHANGED = 'headerHeightChanged';
export const HEADER_HEIGHT_CHANGED_NS = 'header/headerHeightChanged';